import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { Title, Input, Select, Modal, Icon, Button } from '../../modules/modules';
import CountryService from '../../services/CountryService';
import { isTwoLineAddressMode } from '../../helpers/address/isTwoLineAddressMode';
import { getCountyStateRequired } from '../../helpers/country/getCountyStateRequired';
import { vatDescription } from '../../helpers/vatDescription';
import AuthService from '../../services/AuthService';
import CartService from '../../services/CartService';
import { getDeliveryCountriesOptions } from '../../helpers/address/getDeliveryCountriesOptions';
import RequestCompanyChangeModal from './RequestChangeModal';

interface ICustomerDataProps {
  isCompanyLocked: boolean;
  data: any;
  checkingVat: boolean;
  validationVat: any;
  errors: any;
  countries?: any;
  onChange: (e: any) => void;
  isValidVat: () => void;
  requestCompanyChange: MutationFunc;
}

interface ICustomerDataState {
  countryStateChecked?: boolean;
  requestFormOpened: boolean;
}

class CustomerData extends React.Component<ICustomerDataProps, ICustomerDataState> {

  constructor(props: ICustomerDataProps) {
    super(props);
    this.state = {
      requestFormOpened: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  public toggleRequestForm = () => {
    this.setState({ requestFormOpened: !this.state.requestFormOpened });
  }

  public async componentDidMount() {
    // const currentCountry = CountryService.GetInstance().country;
    // const invoiceCountrySelectedByCustomer = CartService.GetInstance().invoiceCountryByCustomer;
    // const deliveryCountrySelectedByCustomer = CartService.GetInstance().deliveryCountryByCustomer;
    // nastavení výchozí země do fakt. adresy
    // if (invoiceCountrySelectedByCustomer && invoiceCountrySelectedByCustomer.name) {
    //   await this.props.onChange({
    //     target: {
    //       name: 'AddressCountry', value: invoiceCountrySelectedByCustomer.name
    //     }
    //   });
    // } else if (currentCountry && currentCountry.name) {
    //   await this.props.onChange({
    //     target: {
    //       name: 'AddressCountry', value: currentCountry.name
    //     }
    //   });
    // }
    // nastavení výchozí země do doručovací adresy
    // if (deliveryCountrySelectedByCustomer && deliveryCountrySelectedByCustomer.name) {
    //   await this.props.onChange({
    //     target: {
    //       name: 'DeliveryAddressCountry', value: deliveryCountrySelectedByCustomer.name
    //     }
    //   });
    // } else if (invoiceCountrySelectedByCustomer && invoiceCountrySelectedByCustomer.name) {
    //   await this.props.onChange({
    //     target: {
    //       name: 'DeliveryAddressCountry', value: invoiceCountrySelectedByCustomer.name
    //     }
    //   });
    // } else if (!this.props.data.DeliveryAddressCountry) {
    //   if (currentCountry && currentCountry.name) {
    //     await this.props.onChange({
    //       target: {
    //         name: 'DeliveryAddressCountry', value: currentCountry.name
    //       }
    //     });
    //   }
    // }
  }

  public async componentDidUpdate() {
    // kontrola předvyplněného státu z účtu zákazníka
    if ('string' === typeof this.props.data.AddressCountyState && (this.props.data.AddressCountyState.length > 0) && !this.state.countryStateChecked) {
      const invoiceCountry = this.getInvoiceCountry();
      if (getCountyStateRequired(invoiceCountry)) {
        const definedState = invoiceCountry.states.find((s: GQL.ICountryState) => s.name.trim().toLowerCase() === this.props.data.AddressCountyState.trim().toLowerCase());
        if (definedState) {
          this.onChange({ target: { name: 'AddressCountyState', value: definedState.name }});
          this.setState({ countryStateChecked: true });
        } else {
          this.onChange({ target: { name: 'AddressCountyState', value: undefined }});
          this.setState({ countryStateChecked: true });
        }
      } else {
        this.setState({ countryStateChecked: true });
      }
    }
  }

  private getInvoiceCountry() {
    const { countries, data } = this.props;
    return countries && !countries.loading && countries.countries
      ? countries.countries.find((c: GQL.ICountry) => c.name === data.AddressCountry)
      : null;
  }

  private getDeliveryCountry() {
    const { countries, data } = this.props;

    return countries && !countries.loading && countries.countries
      ? countries.countries.find((c: GQL.ICountry) => c.name === data.DeliveryAddressCountry)
      : null;
  }

  private isValidVat = (e: React.MouseEvent<HTMLElement>) => {
    const { isValidVat } = this.props;
    e.preventDefault();
    isValidVat();
  }

  private renderInput(name: string, label: string, options: any = {}) {
    const { data } = this.props;
    let element: any = null;

    if (options.type && options.type === 'select') {
      if (!data[name] && !options.defaultValue && Array.isArray(options.options)) {
        options.options.push({ value: 'Select value', label: 'Select value' });
      }

      element = (
        <Select
          name={name}
          label={label}
          placeholder={options.placeholder !== undefined ? options.placeholder : null}
          required={options.required !== undefined ? options.required === true : false}
          options={options.options || undefined}
          disabled={options.disabled || false}
          value={data[name] || options.defaultValue || 'Select value'}
          clearFilterDisabled={true}
          onChange={(e: any) => {
            if (e.target.value && e.target.value.value) {
              this.onChange({ target: { name, value: e.target.value.value } });
            }
          }}
        />
      );
    } else {
      element = (
        <Input
          type={options.type || 'text'}
          name={name}
          label={label}
          required={options.required !== undefined ? options.required === true : false}
          disabled={options.disabled || false}
          value={data[name] || ''}
          onChange={this.onChange}
          maxLength={'number' === typeof options.maxLength ? options.maxLength : undefined}
        />
      );
    }

    const hasError = this.props.errors[name] === true;

    return (
      <div className={`form__item${hasError ? ' hasError' : ''}`}>
        {element}

        {name === 'CompanyVatNumber' && this.props.validationVat.validationRequired && 
          <>
            {this.props.checkingVat === true &&
              <span className="vatNumber vatNumber__checking">Verifying {vatDescription()} number ...</span>}
            {this.props.checkingVat !== true && this.props.validationVat &&
              <>
                  {this.props.validationVat.valid === true
                    ? <span className="vatNumber vatNumber__valid">{vatDescription()} number is valid.</span>
                    : <span className="vatNumber vatNumber__notValid">{vatDescription()} {this.props.validationVat.message}</span>
                }
              </>}
          </>}

        {this.props.errors[name] === true &&
          <div className="form__error">Please enter value</div>}
      </div>
    );
  }

  public render() {
    const { country } = CountryService.GetInstance();
    const invoiceCountry = CartService.GetInstance().invoiceCountryByCustomer;
    const { requestFormOpened } = this.state;
    const { data, countries, isCompanyLocked } = this.props;

    const countryOptions = countries && countries.countries
      ? countries.countries
        .filter((c: GQL.ICountry) => !!c.code)
        .map((c: GQL.ICountry) => ({ value: c.name, label: c.name }))
      : country
        ? [{ value: country.name, label: country.name }]
        : [];

    const deliveryCountryOptions = getDeliveryCountriesOptions(countries.countries, invoiceCountry);

    // státy zemí, fakturační a dodací
    const countryStates = this.getCountryStatesToSelect(data.AddressCountry);
    const deliveryCountryStates = this.getCountryStatesToSelect(data.DeliveryAddressCountry);

    const deliveryCountry = this.getDeliveryCountry();

    // jsme v US?
    const isInUS = deliveryCountry &&
      deliveryCountry.code &&
      deliveryCountry.code.toLowerCase() === 'us';

    return (
      <form>
        {this.renderInput('Firstname', 'First name', { required: true })}
        {this.renderInput('Lastname', 'Last name', { required: true })}
        {this.renderInput('Email', 'E-mail', { type: 'email', required: true, disabled: AuthService.GetInstance().loggedIn })}
        {this.renderInput('Phone', 'Phone', { required: true })}

        <Title type="shopping-cart-subtitle">
          Billing information
        </Title>
        {isTwoLineAddressMode()
          ? <React.Fragment>
            <div className="row">
              <div className="col-12">
                {this.renderInput('AddressLine1', 'Street address', { required: true })}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderInput('AddressLine2', 'Address line 2')}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                {this.renderInput('AddressCity', 'City', { required: true })}
              </div>
              <div className="col-sm-4">
                {this.renderInput('AddressZip', 'ZIP', { required: true })}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {countryStates.length > 0 &&
                  this.renderInput('AddressCountyState', 'County / State', {
                    type: 'select',
                    placeholder: 'County / State',
                    required: getCountyStateRequired(this.getInvoiceCountry()),
                    options: countryStates
                  })}
                {countryStates.length === 0 &&
                  this.renderInput('AddressCountyState', 'County / State')}
              </div>
            </div>
          </React.Fragment>
          : <React.Fragment>
            <div className="row">
              <div className="col-sm-8">
                {this.renderInput('AddressStreet', 'Street', { required: true })}
              </div>
              <div className="col-sm-4">
                {this.renderInput('AddressStreetNumber', 'Number', { required: true })}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                {this.renderInput('AddressCity', 'City', { required: true })}
              </div>
              <div className="col-sm-4">
                {this.renderInput('AddressZip', 'ZIP', { required: true })}
              </div>
            </div>
          </React.Fragment>}

        <div className="form__item">
          {this.renderInput('AddressCountry', 'Country', { type: 'select', options: countryOptions, defaultValue: country && country.id, disabled: isCompanyLocked })}
        </div>

        <Input
          type="checkbox"
          label="Different delivery address"
          value={this.props.data.AnotherDeliveryAddress}
          onChange={(e: any) => this.onChange({ target: { name: 'AnotherDeliveryAddress', value: e.target.checked } })}
        />
        {this.props.data.AnotherDeliveryAddress === true &&
          <React.Fragment>
            <Title type="shopping-cart-subtitle">
              Delivery address
            </Title>
            <div className="row">
              <div className="col-12">
                {this.renderInput('DeliveryFirstName', 'First name')}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderInput('DeliveryLastName', 'Last name')}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderInput('DeliveryPhone', 'Phone', { required: true })}
              </div>
            </div>
            {isTwoLineAddressMode()
              ? <React.Fragment>
                <div className="row">
                  <div className="col-12">
                    {this.renderInput('DeliveryAddressLine1', 'Street address', { required: true })}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {this.renderInput('DeliveryAddressLine2', 'Address line 2')}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8">
                    {this.renderInput('DeliveryAddressCity', 'City', { required: true })}
                  </div>
                  <div className="col-sm-4">
                    {this.renderInput('DeliveryAddressZip', 'ZIP', { required: true })}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {deliveryCountryStates.length > 0 &&
                      this.renderInput('DeliveryAddressCountyState', 'County / State', {
                        type: 'select',
                        placeholder: 'County / State',
                        required: getCountyStateRequired(this.getDeliveryCountry()),
                        options: deliveryCountryStates
                      })}
                    {deliveryCountryStates.length === 0 &&
                      this.renderInput('DeliveryAddressCountyState', 'County / State')}
                  </div>
                </div>
              </React.Fragment>
              : <React.Fragment>
                <div className="row">
                  <div className="col-sm-8">
                    {this.renderInput('DeliveryAddressStreet', 'Street')}
                  </div>
                  <div className="col-sm-4">
                    {this.renderInput('DeliveryAddressStreetNumber', 'Number')}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8">
                    {this.renderInput('DeliveryAddressCity', 'City')}
                  </div>
                  <div className="col-sm-4">
                    {this.renderInput('DeliveryAddressZip', 'ZIP')}
                  </div>
                </div>
              </React.Fragment>}

            <div className="form__item">
              {this.renderInput(
                'DeliveryAddressCountry',
                'Country',
                {
                  type: 'select',
                  options: deliveryCountryOptions,
                  defaultValue: deliveryCountry && deliveryCountry.id
                })}
            </div>
          </React.Fragment>}

        <Input
          disabled={isCompanyLocked}
          type="checkbox"
          name={'CompanyInformation'}
          label="Company information"
          value={this.props.data.CompanyInformation === true}
          onChange={(e: any) => this.onChange({ target: { name: 'CompanyInformation', value: e.target.checked } })}
        />
        {this.props.data.CompanyInformation === true &&
          <React.Fragment>
            <Title type="shopping-cart-subtitle">
              Company information
            </Title>
            {this.renderInput('Company', 'Company', { disabled: isCompanyLocked })}
            {country && 'cz' === country.code ? this.renderInput('CompanyRegistrationNumber', 'Registration number') : ''}
            {this.renderInput('CompanyVatNumber', `${isInUS ? 'GST' : 'Vat'} number`, { maxLength: 18, disabled: isCompanyLocked }) /* maxLength je omezení Pohody */}
            {isCompanyLocked && <p className="companyDetailsMessage">
              Company name, VAT ID, and country are locked after validation.<br />
              If you need to change any of these details, please&nbsp;
              <a href="javascript:void(0)" onClick={this.toggleRequestForm} style={{ color: 'red', textDecoration: 'underline' }}>contact our customer support</a>.
            </p>}
          
          </React.Fragment>}

        <Title type="shopping-cart-subtitle">
          Notes
        </Title>
        {this.renderInput('Notes', 'Notes', { type: 'textarea', required: false })}
        {requestFormOpened && <RequestCompanyChangeModal
          customer={CartService.GetInstance().customerData as any}
          requestCompanyChange={this.props.requestCompanyChange}
          toggleRequestForm={this.toggleRequestForm}
        />}
      </form>
    );
  }

  private getCountryStatesToSelect(countryName: string) {
    const { countries } = this.props;
    if (
      countryName
      && countries
      && !countries.loading
      && countries.countries
    ) {
      const country = countries.countries.find((c: GQL.ICountry) => {
        return c.name === countryName;
      });
      if (country && country.states) {
        return country.states.map((s: GQL.ICountryState) => {
          return {
            value: s.name,
            label: s.name,
          };
        });
      }
    }

    return [];
  }

  private onChange(e: any) {
    this.props.onChange(e);
  }
}

export default CustomerData;



// WEBPACK FOOTER //
// ./src/components/CustomerData/CustomerData.tsx